import WindowsIcon from './WindowsIcon'
import MicrosoftIcon from './MicrosoftIcon'
import MacIcon from './MacIcon'
import IosIcon from './IosIcon'
import AndroidIcon from './AndroidIcon'
import LinuxIcon from './LinuxIcon'

export default {
  'sys windows,windows': WindowsIcon,
  'sys microsoft,microsoft': MicrosoftIcon,
  'sys mac,mac': MacIcon,
  'sys ios,ios,topic_ios': IosIcon,
  'sys android,android': AndroidIcon,
  'sys linux,linux': LinuxIcon,
}
